/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Audit_Complete_No_DiscrepanciesInputs */

const en_audit_complete_no_discrepancies = /** @type {(inputs: Audit_Complete_No_DiscrepanciesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audit complete — ${i?.count} items checked, no discrepancies`)
};

const es_audit_complete_no_discrepancies = /** @type {(inputs: Audit_Complete_No_DiscrepanciesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Auditoria completa — ${i?.count} articulos verificados, sin discrepancias`)
};

/**
* | output |
* | --- |
* | "Audit complete — {count} items checked, no discrepancies" |
*
* @param {Audit_Complete_No_DiscrepanciesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const audit_complete_no_discrepancies = /** @type {((inputs: Audit_Complete_No_DiscrepanciesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Complete_No_DiscrepanciesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_audit_complete_no_discrepancies(inputs)
	return es_audit_complete_no_discrepancies(inputs)
});